import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  header?: React.ReactNode | string;
  description?: React.ReactNode | string;
  icon?: React.ReactNode;
  allowHorizontalScroll?: boolean;
}

/**
 * PageContainer is a responsive container that:
 * - Adapts to the sidebar state
 * - Provides consistent padding
 * - Replaces the fixed max-w-7xl with responsive width
 * - Automatically adjusts based on sidebar collapse state
 * - Optionally shows a header with title, description and icon
 */
export function PageContainer({
  children,
  className = '',
  noPadding = false,
  header,
  description,
  icon,
  allowHorizontalScroll = false
}: PageContainerProps) {
  // Se abbiamo header/description, mostra un'intestazione di pagina
  const showHeader = header || description || icon;
  
  return (
    <div className={`w-full ${allowHorizontalScroll ? 'overflow-x-auto' : 'overflow-x-hidden'} ${!noPadding ? 'px-4 sm:px-6 py-6 content-container' : ''} sidebar-aware-content ${className}`}>
      {showHeader && (
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-1">
            {icon && (
              <div className="flex-shrink-0 text-gray-500 dark:text-gray-400">
                {icon}
              </div>
            )}
            {header && (
              <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
                {header}
              </h1>
            )}
          </div>
          {description && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-2xl">
              {description}
            </p>
          )}
        </div>
      )}
      <div className="w-full mx-auto">
        {children}
      </div>
    </div>
  );
}